export default "/assets/images/baby.4444bc23d2106214.png";